import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PermittedRoutes from '../../shared/PermittedRoutes';
import Link from './Link';

class NavLinkProvider extends Component {
  componentDidMount() {
    const { location, history } = this.props;
    if (!PermittedRoutes.isPermitted(location.pathname)) {
      history.push(PermittedRoutes.first);
    }
  }

  renderLink = props => {
    if (props.if === false) return false;
    return <Link onMount={this.handleLinkMount} {...props} />;
  };

  handleLinkMount = linkProps => {
    PermittedRoutes.register(linkProps.to);
  };

  render() {
    return this.props.children(this.renderLink);
  }
}

export default withRouter(NavLinkProvider);
